import { computed, ref } from 'vue';
import { isEmpty, mapValues, omitBy } from 'lodash-es';

export const useConfiguration = () => {
  const configuration = ref({
    engraving: null,
    options: {
      frame: null,
      date: null,
      font: null,
      position: null,
      lacquer: null,
    },
    personalisation: {
      bespoke: null,
      font: null,
      initials: null,
      position: null,
      dateOrNumbers: null,
      text: null,
      sign: null,
      monument: null,
      flower: null,
      polo: null,
    },
    placement: [],
  });

  const filteredConfiguration = computed(() => filterConfiguration(configuration.value));

  const filterConfiguration = (config) =>
    omitBy(
      mapValues(config, (item) => (typeof item === 'object' ? filterConfiguration(item) : item)),
      (item) => (typeof item === 'object' ? isEmpty(item) : item === null),
    );

  return {
    configuration,
    filteredConfiguration,
  };
};
